module.exports = __webpack_public_path__ + "static/media/mitelFavicon.a2303f73.ico";